'use client';

import { setClarityConsent } from './clarity';
import { setFirebaseAnalyticsConsent } from './firebaseAnalytics';
import { setAppsFlyerConsent } from './appsflyerAnalytics';

/**
 * Single entry point for the user's app-analytics consent (contract 8). Fans the
 * choice out to every native analytics service so they stay in lockstep:
 * granting enables Clarity recording, Firebase Analytics collection and AppsFlyer
 * attribution, revoking disables them. Each underlying call already no-ops on web.
 */
export const setAppAnalyticsConsent = async (enabled: boolean): Promise<void> => {
  await Promise.all([
    setClarityConsent(enabled),
    setFirebaseAnalyticsConsent(enabled),
    setAppsFlyerConsent(enabled),
  ]);
};
